import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ArrowUpRight, MapPin } from "lucide-react";
import axios from "axios";

const FALLBACK = [
  {
    city: "Москва",
    venue: "Театр-ресторан «Наблюдатель»",
    date: "12 ИЮЛЯ 2026",
    status: "ВЫБРАТЬ МЕСТО",
  },
  {
    city: "Москва",
    venue: "Театр-ресторан «Наблюдатель»",
    date: "19 ИЮЛЯ 2026",
    status: "ВЫБРАТЬ МЕСТО",
  },
  {
    city: "Москва",
    venue: "Театр-ресторан «Наблюдатель»",
    date: "26 ИЮЛЯ 2026",
    status: "ВЫБРАТЬ МЕСТО",
  },
];

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function statusColor(s) {
  if (s === "Распродано" || s === "Agotado") return "#7a3a1a";
  if (s === "Мало билетов" || s === "Pocas Entradas") return "#FFB84D";
  return "#E57324";
}

export default function TourDates() {
  const [dates, setDates] = useState(FALLBACK);

  useEffect(() => {
    axios
      .get(`${API}/tour-dates`)
      .then((r) => {
        if (r.data?.dates?.length) setDates(r.data.dates);
      })
      .catch(() => {});
  }, []);

  return (
    <section
      id="fechas"
      className="relative py-16 lg:py-24"
      data-testid="tour-dates-section"
    >
      <div className="container-custom">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
          className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16"
        >
          <div className="md:order-2">
            <div className="eyebrow mb-5">· Ближайшие концерты</div>
            <h2
              className="font-serif font-light leading-[1] tracking-tight"
              style={{ fontSize: "clamp(2.6rem, 5.6vw, 4.6rem)", color: "#F2E9DE" }}
              data-testid="tour-dates-title"
            >
              Июль <em style={{ color: "#E57324" }}>2026</em>
            </h2>
          </div>
          <div className="md:order-1 max-w-sm">
            <p className="text-[#A99F96]/60 text-sm mt-4 leading-relaxed">
              Если вы хотите узнать подробности о мероприятии или о бронировании столов, позвоните напрямую в театр-ресторан «Наблюдатель»: <a href="tel:+79852618565" className="text-[#E57324] hover:text-[#F08A46] transition-colors">+7 (985) 261-85-65</a>. Блюда и напитки оплачиваются отдельно и в стоимость билета не входят. Рекомендуем приходит за 30 минут до начала.
            </p>
          </div>
        </motion.div>

        <div className="flex flex-col" data-testid="tour-dates-list">
          {dates.map((d, i) => (
            <motion.a
              key={`${d.city}-${i}`}
              href="https://afisha.yandex.ru/moscow/musical-play/vechnye-shopen?source=place&refererSurface=selection"
              target="_blank"
              rel="noopener noreferrer"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.7, delay: i * 0.08 }}
              data-testid={`tour-date-${i}`}
              className="group border-t border-[#F2E9DE]/10 last:border-b py-8 md:py-10 flex flex-col md:flex-row md:items-center gap-4 md:gap-8 transition-all hover:pl-4"
              style={{ transition: "padding .4s ease" }}
            >
              <div
                className="font-serif font-light text-[#F2E9DE] leading-none"
                style={{ fontSize: "clamp(1.6rem, 2.6vw, 2.2rem)", minWidth: 280 }}
              >
                {d.city}
              </div>
              <div className="flex-1 flex flex-col md:flex-row md:items-center gap-2 md:gap-8">
                <div className="flex items-center gap-2 text-[#A99F96]">
                  <MapPin size={14} />
                  <span className="text-sm">{d.venue}</span>
                </div>
                <div className="text-sm tracking-[0.18em] uppercase text-[#A99F96]">
                  {d.date}
                </div>
              </div>
              <div className="flex items-center gap-5">
                <span
                  className="text-xs tracking-[0.22em] uppercase"
                  style={{ color: statusColor(d.status) }}
                >
                  {d.status}
                </span>
                <ArrowUpRight
                  size={20}
                  className="text-[#A99F96] group-hover:text-[#E57324] transition-all group-hover:translate-x-1 group-hover:-translate-y-1"
                />
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}

